import Section1 from './SectionManager/Section1';
import Section2 from './SectionManager/Section2';
import Section3 from './SectionManager/Section3';
import Section4 from './SectionManager/Section4';
import Section5 from './SectionManager/Section5';
import Section8 from './SectionManager/Section8';
import Section9 from './SectionManager/Section9';
import Section12 from './SectionManager/Section12';
import SectionPartner from '../RouteCompanyCityToCity/SectionManager/SectionPartner/desktop';
import SectionFamousRoute from '../RouteCompanyCityToCity/SectionManager/SectionFamousRoute/desktop';
import SectionFamousToRoute from '../RouteCompanyCityToCity/SectionManager/SectionFamousToRoute/desktop';
import SectionWhyBookUs from '../RouteCompanyCityToCity/SectionManager/SectionWhyBookUs/desktop';

import SectionPartnerMobile from '../RouteCompanyCityToCity/SectionManager/SectionPartner';
import SectionFamousRouteMobile from '../RouteCompanyCityToCity/SectionManager/SectionFamousRoute';
import SectionFamousToRouteMobile from '../RouteCompanyCityToCity/SectionManager/SectionFamousToRoute';
import SectionWhyBookUsMobile from '../RouteCompanyCityToCity/SectionManager/SectionWhyBookUs';

/* eslint-disable no-irregular-whitespace */
export const MENU_BAR = [
  { label: 'Tìm chuyến' },
  { label: 'Săn vé' },
  { label: 'Vé Tết' },
  { label: 'Thông tin' },
  // { label: 'Di chuyển' },
];

export const CONTENT_SECTION = {
  section1: {
    isHaveDivider: true,
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: 'Săn vé máy bay giá rẻ nhất {{route_name}}',
      component: 'h2',
    },
    note: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    note2: {
      vi: 'Thời gian khởi hành theo giờ địa phương',
    },
    description: {
      vi: 'Bấm vào ngày để xem ngay các giờ bay có giá cực rẻ {{route_name}}.',
    },
    component: Section1,
  },
  section2: {
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: '{{route_name}} Hồ Chí Minh - Hà Nội Thông tin lịch bay các chuyến có giá tốt nhất tuần này',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào để đặt ngay chuyến có giờ bay rẻ nhất trong tuần. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh. ',
    },
    component: Section2,
  },
  section3: {
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: 'Xem chặng bay {{route_name}} có giá rẻ nhất trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào ngày để xem ngay giờ khởi hành, tiện ích, hãng bay có giá tốt nhất đi {{to_name}}',
    },
    component: Section3,
  },
  section4: {
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: 'Thống kê Top 3 ngày có giá vé thấp nhất {{route_name}} trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào mỗi ngày để xem giờ bay và những chuyến có giá thấp nhất giữa các hãng hàng không cùng chặng hành trình này',
    },
    component: Section4,
  },
  section5: {
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: 'Hãng hàng không có giá vé máy bay {{route_name}} rẻ nhất trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Mỗi hàng bên dưới thể hiện giá vé thấp nhất của mỗi hãng bay ở chặng {{route_name}} và ngày có giá thấp nhất trong 1 tháng tới. Vui lòng bấm vào từng dòng bên dưới để đặt vé. ',
    },
    component: Section5,
  },
  section6: {
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: 'Mẹo săn vé máy bay giá rẻ {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Thời điểm Covid thì bạn có thể mua vé gần ngày đi vì giá vẫn thấp. Nhu cầu đi lại của mọi người vẫn chưa cao nên tỉ lệ lấp đầy của hãng cũng không cao dẫn đến giá sẽ không cao như các năm trước. Tuy nhiên thị trường đang dần hồi phục nên các đợt cao điểm như Lễ, Tết thì giá vẫn rất cao vì cung không đủ cầu. <br/>

      Mẹo để săn vé rẻ nhất là bạn nên book vé sớm trước vài tuần bằng cách xem lịch ở trang chủ của Goyolo.com. Chúng tôi liệt kê sẵn giá tất cả các ngày trong tháng với những ngày nào giá thấp nhất giữa tất cả các hãng bay được tô đậm như hình bên trên. Bạn chọn ngày nào có giá tốt nhất và phù hợp lịch di chuyển của bạn.`,
    },
    component: null,
  },
  section7: {
    isNewYear: true,
    isHaveDivider: true,
    id: 've-tet',
    title: {
      vi: 'Vé máy bay giá rẻ Tết {{luna_year}} {{route_name}}',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Vé máy bay Tết {{luna_year}} {{route_name}} đã mở bán từ các hãng {{route_airline}} với mức giá cực hấp dẫn.`,
    },
    component: null,
  },
  section8: {
    isNewYear: true,
    id: 've-tet',
    title: {
      vi: 'Bảng giá vé máy bay Tết {{luna_year}} giá rẻ nhất giữa {{route_airline}} ',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [
        'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
        'Thời gian khởi hành theo giờ địa phương',
        'Giá vé có thể thay đổi tùy thuộc vào thời gian đặt vé và hạng ghế được chọn.',
      ],
    },
    description: {
      vi: `
      Vé máy bay Tết {{luna_year}} {{route_name}} đã mở bán từ các hãng {{route_airline}} với mức giá cực hấp dẫn.`,
    },
    component: Section8,
  },
  section9: {
    isNewYear: true,
    id: 've-tet',
    title: {
      vi: 'Giá vé máy bay Tết {{luna_year}} rẻ nhất {{route_name}} cập nhật {{route_now}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: ['Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn', ' Nhấn vào ngày bất kỳ để xem giờ và hãng hàng không có giá tốt nhất trong ngày đó'],
    },
    description: {
      vi: `
      Giá vé máy bay Tết {{luna_year}} được cập nhật liên tục trên Goyolo.com để giúp cho hành khách có những tấm vé máy bay Tết {{route_name}} giá rẻ nhất. Ngay từ {{route_now}}, các hãng hàng không nội địa {{route_airline}} đã mở bán vé máy bay Tết {{luna_year}}. Hãy cùng Goyolo.com theo dõi bảng giá vé các tháng Tết {{luna_year}} để đặt vé sớm.`,
    },
    component: Section9,
  },
  section10: {
    isNewYear: true,
    id: 've-tet',
    title: {
      vi: 'Thời điểm săn vé máy bay {{company}} {{route_name}} Tết {{luna_year}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Khi có lịch nghỉ Tết, bạn nên tiến hành book ngay vé máy bay Tết đi {{to_name}}. Bí kíp là bạn cũng có thể đặt vé trước vài tháng vì mua vé càng sớm, bạn sẽ dễ dàng lựa chọn được ngày giờ bay ưng ý với mức giá khuyến mãi rẻ nhất. Tìm vé càng cận Tết sẽ dễ rơi vào tình huống cháy vé hoặc phải mua vé với giá cao ngất ngưỡng. Vậy việc booking vé Tết càng sớm luôn có lợi hơn cả.`,
    },
    component: null,
  },
  section11: {
    isNewYear: false,
    id: 've-tet',
    title: {
      vi: 'Lịch bán vé máy bay Tết {{luna_year}} {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Hãng hàng không {{company}} chặng {{route_name}} trong 3 đợt. Đợt bán vé đầu tiên thường bắt đầu tầm giữa tháng 9 và tháng 10, đợt 2 tầm tháng 10 và tháng 11, đợt còn lại cho đến Tết. Thường thì vé được bán trong đợt 1 có giá rẻ nhất với số lượng nhiều nhất, càng về gần Tết vé máy bay càng ít dần và giá càng bị đẩy lên cao theo cơ chế cung cầu. Do đó, thời điểm săn mua vé máy bay Tết {{luna_year}} tốt hơn hết bạn nên mua vé ngay khi các hãng mở bán trong đợt đầu tiên để có thể chắc chắn mình mua được vé với giá tốt nhất.`,
    },
    component: null,
  },
  section12: {
    isNewYear: false,

    isHaveDivider: true,
    id: 'thong-tin',
    title: {
      vi: 'Thông tin chuyến bay {{route_name}}',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: `
      Chặng bay {{route_name}} dài khoảng {{distance}} km. Trung bình mỗi ngày có khoảng {{average_flight_count}} chuyến bay trên Goyolo.com, chuyến sớm nhất cất cánh lúc {{earliest_pickup_time}}, chuyến bay trễ nhất {{route_name}} cất cánh vào lúc {{latest_pickup_time}}, được vận hành bởi các hãng máy bay {{route_airline}}... Mất khoảng {{average_duration}} phút để hoàn thành chuyến bay {{route_name}}.`,
    },
    description: {
      vi: `
      Xem các thông tin về thời gian bay, tổng chiều dài đường bay, sân bay, lịch bay {{route_name}}.`,
    },
    component: Section12,
  },
  SectionParner: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Hơn 1500+ đối tác của Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionPartnerMobile,
  },
  SectionFamousFromRoute: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Các chặng bay phổ biến từ {{from_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionFamousRouteMobile,
  },
  SectionFamousToRoute: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Các chặng bay phổ biến từ {{to_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionFamousToRouteMobile,
  },
  SectionWhyBookUs: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Tại sao bạn nên đặt vé qua Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionWhyBookUsMobile,
  },
};

export const CONTENT_SECTION_DESKTOP = {
  section1: {
    isHaveDivider: true,
    isNewYear: false,
    alignCenter: true,
    id: 'san-ve',
    title: {
      vi: 'Săn vé máy bay giá rẻ nhất {{route_name}}',
      component: 'h2',
    },
    note: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    note2: {
      vi: 'Thời gian khởi hành theo giờ địa phương',
    },
    description: {
      vi: 'Bấm vào ngày để xem ngay các giờ bay có giá cực rẻ {{route_name}}.',
    },
    component: Section1,
  },
  section2: {
    isNewYear: false,
    alignCenter: true,
    id: 'san-ve',
    title: {
      vi: 'Check giờ bay và giá vé rẻ nhất tuyến {{route_name}} 7 ngày tới từ hôm nay',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào để đặt ngay chuyến có giờ bay rẻ nhất trong tuần. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh. ',
    },
    component: Section2,
  },
  section3: {
    isNewYear: false,
    alignCenter: true,
    id: 'san-ve',
    title: {
      vi: 'Xem chặng bay {{route_name}} có giá rẻ nhất trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào ngày để xem ngay giờ khởi hành, tiện ích, hãng bay có giá tốt nhất đi {{to_name}}',
    },
    component: Section3,
  },
  section4: {
    isNewYear: false,
    alignCenter: true,
    id: 'san-ve',
    title: {
      vi: 'Thống kê Top 3 ngày có giá vé thấp nhất {{route_name}} trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào mỗi ngày để xem giờ bay và những chuyến có giá thấp nhất giữa các hãng hàng không cùng chặng hành trình này',
    },
    component: Section4,
  },
  section5: {
    isNewYear: false,
    alignCenter: true,
    id: 'san-ve',
    title: {
      vi: 'Hãng hàng không có giá vé máy bay {{route_name}} rẻ nhất trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Mỗi hàng bên dưới thể hiện giá vé thấp nhất của mỗi hãng bay ở chặng {{route_name}} và ngày có giá thấp nhất trong 1 tháng tới. Vui lòng bấm vào từng dòng bên dưới để đặt vé. ',
    },
    component: Section5,
  },
  section6: {
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: 'Mẹo săn vé máy bay giá rẻ {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Thời điểm Covid thì bạn có thể mua vé gần ngày đi vì giá vẫn thấp. Nhu cầu đi lại của mọi người vẫn chưa cao nên tỉ lệ lấp đầy của hãng cũng không cao dẫn đến giá sẽ không cao như các năm trước. Tuy nhiên thị trường đang dần hồi phục nên các đợt cao điểm như Lễ, Tết thì giá vẫn rất cao vì cung không đủ cầu. <br/>

      Mẹo để săn vé rẻ nhất là bạn nên book vé sớm trước vài tuần bằng cách xem lịch ở trang chủ của Goyolo.com. Chúng tôi liệt kê sẵn giá tất cả các ngày trong tháng với những ngày nào giá thấp nhất giữa tất cả các hãng bay được tô đậm như hình bên trên. Bạn chọn ngày nào có giá tốt nhất và phù hợp lịch di chuyển của bạn.`,
    },
    component: null,
  },
  section7: {
    isNewYear: true,
    isHaveDivider: true,
    id: 've-tet',
    title: {
      vi: 'Vé máy bay giá rẻ Tết {{luna_year}} {{route_name}}',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: null,
  },
  section8: {
    isNewYear: true,
    alignCenter: true,
    id: 've-tet',
    title: {
      vi: 'Bảng giá vé máy bay Tết {{luna_year}} giá rẻ nhất giữa {{route_airline}} ',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [
        'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
        'Thời gian khởi hành theo giờ địa phương',
        'Giá vé có thể thay đổi tùy thuộc vào thời gian đặt vé và hạng ghế được chọn.',
      ],
    },
    description: {
      vi: `
      Vé máy bay Tết {{luna_year}} {{route_name}} đã mở bán từ các hãng {{route_airline}} với mức giá cực hấp dẫn.`,
    },
    component: Section8,
  },
  section9: {
    isNewYear: true,
    alignCenter: true,
    id: 've-tet',
    title: {
      vi: 'Giá vé máy bay Tết {{luna_year}} rẻ nhất {{route_name}} cập nhật {{route_now}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: ['Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn', ' Nhấn vào ngày bất kỳ để xem giờ và hãng hàng không có giá tốt nhất trong ngày đó'],
    },
    description: {
      vi: `
      Giá vé máy bay Tết {{luna_year}} được cập nhật liên tục trên Goyolo.com để giúp cho hành khách có những tấm vé máy bay Tết {{route_name}} giá rẻ nhất. Ngay từ {{route_now}}, các hãng hàng không nội địa {{route_airline}} đã mở bán vé máy bay Tết {{luna_year}}. Hãy cùng Goyolo.com theo dõi bảng giá vé các tháng Tết {{luna_year}} để đặt vé sớm.`,
    },
    component: Section9,
  },
  section10: {
    isNewYear: true,
    id: 've-tet',
    title: {
      vi: 'Thời điểm săn vé máy bay {{company}} {{route_name}} Tết {{luna_year}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Khi có lịch nghỉ Tết, bạn nên tiến hành book ngay vé máy bay Tết đi {{to_name}}. Bí kíp là bạn cũng có thể đặt vé trước vài tháng vì mua vé càng sớm, bạn sẽ dễ dàng lựa chọn được ngày giờ bay ưng ý với mức giá khuyến mãi rẻ nhất. Tìm vé càng cận Tết sẽ dễ rơi vào tình huống cháy vé hoặc phải mua vé với giá cao ngất ngưỡng. Vậy việc booking vé Tết càng sớm luôn có lợi hơn cả.`,
    },
    component: null,
  },
  section11: {
    isNewYear: false,
    id: 've-tet',
    title: {
      vi: 'Lịch bán vé máy bay Tết {{luna_year}} {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Hãng hàng không {{company}} chặng {{route_name}} trong 3 đợt. Đợt bán vé đầu tiên thường bắt đầu tầm giữa tháng 9 và tháng 10, đợt 2 tầm tháng 10 và tháng 11, đợt còn lại cho đến Tết. Thường thì vé được bán trong đợt 1 có giá rẻ nhất với số lượng nhiều nhất, càng về gần Tết vé máy bay càng ít dần và giá càng bị đẩy lên cao theo cơ chế cung cầu. Do đó, thời điểm săn mua vé máy bay Tết {{luna_year}} tốt hơn hết bạn nên mua vé ngay khi các hãng mở bán trong đợt đầu tiên để có thể chắc chắn mình mua được vé với giá tốt nhất.`,
    },
    component: null,
  },
  section12: {
    isNewYear: false,
    alignCenter: true,
    isHaveDivider: true,
    id: 'thong-tin',
    title: {
      vi: 'Thông tin chuyến bay {{route_name}}',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: `
      Chặng bay {{route_name}} dài khoảng {{distance}} km. Trung bình mỗi ngày có khoảng {{average_flight_count}} chuyến bay trên Goyolo.com, chuyến sớm nhất cất cánh lúc {{earliest_pickup_time}}, chuyến bay trễ nhất {{route_name}} cất cánh vào lúc {{latest_pickup_time}}, được vận hành bởi các hãng máy bay {{route_airline}}... Mất khoảng {{average_duration}} phút để hoàn thành chuyến bay {{route_name}}.`,
    },
    description: {
      vi: `
      Xem các thông tin về thời gian bay, tổng chiều dài đường bay, sân bay, lịch bay {{route_name}}.`,
    },
    component: Section12,
  },
  SectionParner: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Hơn 1500+ đối tác của Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionPartner,
  },
  SectionFamousFromRoute: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Các chặng bay phổ biến từ {{from_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionFamousRoute,
  },
  SectionFamousToRoute: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Các chặng bay phổ biến từ {{to_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionFamousToRoute,
  },
  SectionWhyBookUs: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Tại sao bạn nên đặt vé qua Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionWhyBookUs,
  },
};

export const metaFaqJson = `
{
  "@context": "https://schema.org",
  "@type": "QAPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "Giá vé máy bay ngày hôm nay {{route_name}}",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hiện tại giá vé đi {{to_name}} thấp nhất là từ {{min_fare}}, khởi hành lúc {{latest_pickup_time}} giờ và vận hành bởi {{route_airline}}."
    }
  },{
    "@type": "Question",
    "name": "Chuyến bay {{route_name}} khởi hành sớm nhất hôm nay?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} có khởi hành sớm nhất là lúc {{latest_pickup_time}} giờ, được vận hành bởi {{route_airline}}."
    }
  },{
    "@type": "Question",
    "name": "Chuyến bay {{route_name}} khởi hành trễ nhất hôm nay?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} có khởi hành trễ nhất là lúc {{latest_pickup_time}} giờ, được vận hành bởi {{route_airline}}."
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể tìm vé máy bay {{route_name}} khuyến mãi như thế nào?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Bạn có thể tìm kiếm chương trình khuyến mãi tại mục 'Mẹo săn vé máy bay giá rẻ {{route_name}}' hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com."
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể mua vé máy bay đi {{to_name}} 247 qua Goyolo.com.com được không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chúng tôi hoạt động tất cả các ngày kể cả thứ 7, chủ nhật và ngày Lễ, Tết bạn có thể đặt vé bất cứ khi nào có nhu cầu."
    }
  },{
    "@type": "Question",
    "name": "Goyolo.com có bán vé máy bay Tết đi {{to_name}} năm nay không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Goyolo.com có mở bán vé máy bay Tết và cả Vé xe khách của các thương hiệu uy tín {{route_name}}, với mức giá ưu đãi nhất."
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể tìm vé máy bay {{route_name}} khuyến mãi như thế nào?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Bạn có thể tìm kiếm chương trình khuyến mãi tại mục 'Mẹo săn vé máy bay giá rẻ {{route_name}}' hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com."
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể hủy chuyến bay {{route_name}} không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chính sách và phí hoàn hủy vé cho chuyến bay {{route_name}} thay đổi tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách hoàn vé hay hủy vé. Theo kinh nghiệm hoàn hủy vé máy bay, trong các đợt Tết, quy định hoàn hủy vé thường sẽ thay đổi. Nếu bạn hủy vé càng sớm, chính sách hủy sẽ càng tốt và số tiền bạn được hoàn lại sẽ cao. Lưu ý, trong một số trường hợp, bạn không thể hoàn hủy vé ngay sát giờ khởi hành. Đối với các trường hợp hoàn hủy vé vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách hoàn hủy vé tạo điều kiện hỗ trợ tối đa cho hành khách. Để biết chính sách cụ thể về điều kiện hủy vé, bạn vui lòng tham khảo theo từng hãng bay: Vietnam Airlines, Vietjet Air, Bamboo Airways"
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể đổi ngày giờ chuyến bay {{route_name}} không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chính sách và phí đổi giờ bay, ngày bay cho chuyến bay {{route_name}} khác nhau tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách thay đổi ngày giờ bay. Theo kinh nghiệm đổi vé máy bay, trong các đợt Tết, quy định đổi vé thường sẽ thay đổi. Nếu bạn đổi chuyến bay càng sớm, chính sách đổi sẽ càng tốt. Lưu ý, trong một số trường hợp, bạn không thể đổi vé ngay sát giờ khởi hành.Đối với các trường hợp đổi ngày giờ bay vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách đổi vé tạo điều kiện hỗ trợ tối đa cho hành khách.Để biết chính sách cụ thể về điều kiện đổi chuyến bay, bạn vui lòng tham khảo theo từng hãng bay: Vietnam Airlines, Vietjet Air, Bamboo Airways"
    }
  },{
    "@type": "Question",
    "name": "Giá vé của Goyolo.com đã bao gồm thuế và phụ phí chưa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Giá vé máy bay trên Goyolo.com đã bao gồm tất cả các khoảng thuế, phụ phí, phí cổng thanh toán và là số tiền cuối cùng bạn thanh toán. Nếu bạn thấy giá chênh lệch giữa Goyolo.com với giá vé hiển thị tại hãng bay hay đại lý khác, thường là do giá vé hiển thị ở những nơi này chưa bao gồm thuế, phí, phí cổng thanh toán."
    }
  }]
}
`;

export const FAQ = [
  {
    id: 1,
    title: 'Giá vé máy bay ngày hôm nay {{route_name}}',
    content: 'Hiện tại giá vé đi {{to_name}} thấp nhất là từ {{min_fare}}, khởi hành lúc {{min_price_time}} giờ và vận hành bởi {{route_airline}}.',
    onClick: '',
  },
  {
    id: 2,
    title: 'Chuyến bay {{route_name}} khởi hành sớm nhất hôm nay?',
    content: 'Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} có khởi hành sớm nhất là lúc {{earliest_pickup_time}} giờ, được vận hành bởi {{route_airline}}.',
    onClick: '',
  },
  {
    id: 3,
    title: 'Chuyến bay {{route_name}} khởi hành trễ nhất hôm nay?',
    content: 'Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} có khởi hành trễ nhất là lúc {{latest_pickup_time}} giờ, được vận hành bởi {{route_airline}}.',
    onClick: '',
  },
  {
    id: 4,
    title: 'Tôi có thể tìm vé máy bay {{route_name}} khuyến mãi như thế nào?',
    content: 'Bạn có thể tìm kiếm chương trình khuyến mãi tại mục "Mẹo săn vé máy bay giá rẻ {{route_name}} hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com.',
    onClick: '',
  },
  {
    id: 5,
    title: 'Tôi có thể mua vé máy bay đi {{to_name}} 247 qua Goyolo.com được không?',
    content: 'Chúng tôi hoạt động tất cả các ngày kể cả thứ 7, chủ nhật và ngày Lễ, Tết bạn có thể đặt vé bất cứ khi nào có nhu cầu.',
    onClick: '',
  },
  {
    id: 6,
    title: 'Goyolo.com có bán vé máy bay Tết đi {{to_name}} năm nay không?',
    content: 'Goyolo.com có mở bán vé máy bay Tết và cả Vé xe khách của các thương hiệu uy tín {{route_name}}, với mức giá ưu đãi nhất.',
    onClick: '',
  },
  {
    id: 7,
    title: 'Tôi có thể tìm vé máy bay {{route_name}} khuyến mãi như thế nào?',
    content: 'Bạn có thể tìm kiếm chương trình khuyến mãi tại mục "Mẹo săn vé máy bay giá rẻ {{route_name}} hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com.',
    onClick: '',
  },
  {
    id: 8,
    title: 'Tôi có thể hủy chuyến bay {{route_name}} không?',
    content: `
    Chính sách và phí hoàn hủy vé cho chuyến bay {{route_name}} thay đổi tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách hoàn vé hay hủy vé.<br/>
    Theo kinh nghiệm hoàn hủy vé máy bay, trong các đợt Tết, quy định hoàn hủy vé thường sẽ thay đổi. Nếu bạn hủy vé càng sớm, chính sách hủy sẽ càng tốt và số tiền bạn được hoàn lại sẽ cao. Lưu ý, trong một số trường hợp, bạn không thể hoàn hủy vé ngay sát giờ khởi hành.<br/>
    Đối với các trường hợp hoàn hủy vé vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách hoàn hủy vé tạo điều kiện hỗ trợ tối đa cho hành khách.<br/>
    Để biết chính sách cụ thể về điều kiện hủy vé, bạn vui lòng tham khảo theo từng hãng bay:
    <ul>
      <li>
        <a href=/vn/ve-may-bay/vietnam-airlines.vi>Vietnam Airlines</a> 
      </li> 
      <li>
        <a href=/vn/ve-may-bay/vietjet-air.vi>Vietjet Air </a>
      </li>
      <li>
        <a href=/vn/ve-may-bay/bamboo-airways.vi>Bamboo Airways </a>
      </li>
    </ul>
    `,
    onClick: '',
  },
  {
    id: 9,
    title: 'Tôi có thể đổi ngày giờ chuyến bay {{route_name}} không?',
    content: `
    Chính sách và phí đổi giờ bay, ngày bay cho chuyến bay {{route_name}} khác nhau tuỳ thuộc vào hãng bay, hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách thay đổi ngày giờ bay.
    Theo kinh nghiệm đổi vé máy bay, trong các đợt Tết, quy định đổi vé thường sẽ thay đổi. Nếu bạn đổi chuyến bay càng sớm, chính sách đổi sẽ càng tốt. Lưu ý, trong một số trường hợp, bạn không thể đổi vé ngay sát giờ khởi hành.
    Đối với các trường hợp đổi ngày giờ bay vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách đổi vé tạo điều kiện hỗ trợ tối đa cho hành khách.
    Để biết chính sách cụ thể về điều kiện đổi chuyến bay, bạn vui lòng tham khảo theo từng hãng bay:
    <ul>
      <li>
        <a href=/vn/ve-may-bay/vietnam-airlines.vi>Vietnam Airlines</a> 
      </li> 
      <li>
        <a href=/vn/ve-may-bay/vietjet-air.vi>Vietjet Air </a>
      </li>
      <li>
        <a href=/vn/ve-may-bay/bamboo-airways.vi>Bamboo Airways </a>
      </li>
    </ul>
    `,
    onClick: '',
  },
  {
    id: 10,
    title: 'Giá vé của Goyolo.com đã bao gồm thuế và phụ phí chưa?',
    content: `
    Giá vé máy bay trên Goyolo.com đã bao gồm tất cả các khoảng thuế, phụ phí, phí cổng thanh toán và là số tiền cuối cùng bạn thanh toán. Nếu bạn thấy giá chênh lệch giữa Goyolo.com với giá vé hiển thị tại hãng bay hay đại lý khác, thường là do giá vé hiển thị ở những nơi này chưa bao gồm thuế, phí, phí cổng thanh toán.`,
    onClick: '',
  },
];
